import { render, staticRenderFns } from "./FormbuilderComponent.vue?vue&type=template&id=3f797fa2&scoped=true&"
import script from "./FormbuilderComponent.vue?vue&type=script&lang=js&"
export * from "./FormbuilderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f797fa2",
  null
  
)

export default component.exports